import Vue from "vue";

export const store = Vue.observable({
  jwtPickup: "",
  hashEform: "",
  eform: "",
  user: {},
});

export const mutations = {
  setJwtPickUp(jwt) {
    store.jwtPickup = jwt;
  },

  setHashEform(hash) {
    store.hashEform = hash;
  },

  setEformSelected(eform) {
    store.eform = eform;
  },

  setUserProfile(user) {
    store.user = user;
  },
};
